<div class="login-shell" [@fadeIn]>
  <div class="orb orb-a"></div>
  <div class="orb orb-b"></div>

  <div class="login-layout">
    <section class="brand-panel">
      <img src="assets/images/MAKH Grop.png" alt="MAKH Logo" class="brand-logo">
      <p class="brand-kicker">MAKH PORTAL</p>
      <h1>Operations, Staff and Logistics in one place.</h1>
      <p class="brand-copy">
        Secure access for teams across delivery, supply, maintenance, and administration.
      </p>
      <ul class="brand-points">
        <li>Live operations visibility</li>
        <li>Role-based secure access</li>
        <li>Integrated reporting and analytics</li>
      </ul>
    </section>

    <mat-card class="login-card">
      <h2 class="login-title">Sign In</h2>
      <p class="login-subtitle">Use your company account to continue.</p>

      <form (ngSubmit)="login()" #loginForm="ngForm">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Email</mat-label>
          <input matInput type="email" [(ngModel)]="email" name="email" required email>
          <mat-error *ngIf="loginForm.submitted && !email">Email is required</mat-error>
          <mat-error *ngIf="loginForm.submitted && email && !email.includes('@')">Enter a valid email</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" [(ngModel)]="password" name="password" required minlength="6">
          <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword" aria-label="Toggle password visibility">
            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error *ngIf="loginForm.submitted && !password">Password is required</mat-error>
          <mat-error *ngIf="loginForm.submitted && password && password.length < 6">Minimum 6 characters</mat-error>
        </mat-form-field>

        <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

        <button mat-flat-button class="full-width login-button" [disabled]="loading">
          <mat-progress-spinner *ngIf="loading" diameter="20" mode="indeterminate"></mat-progress-spinner>
          <span *ngIf="!loading">Login to Dashboard</span>
        </button>
      </form>
    </mat-card>
  </div>
</div>
